<template>
    <b-container class="mt-3">
        <b-form @submit="onSubmit">
            <rolesForm :rol="rol" :permisos="permisos" ></rolesForm>
            <b-button  :disabled="errors.any()" type="submit" variant="primary" class="mb-3 mt-3">Guardar</b-button>
            <b-button @click="regresar()" variant="secondary" class="mb-3 mt-3 ml-3">Regresar</b-button>
        </b-form>    
    </b-container>
</template>

<script>
    import validateMixin from '@/mixins/validation' //para usar el mixin de vee-validate
    import rolesForm from '@/components/admin/rolesFormUpdate'
    import {mapActions,mapState} from 'vuex'
    import customMixin from '@/mixins/customMixin'
    import _ from 'lodash'
    export default {
        components:{
            rolesForm
        },     
        mixins : [validateMixin,customMixin],
        data() {
            return {
              
              reset:false,
              permisos:{
                admin:'',
                vendedor:'',
                preprensa:'',
                ingenieria:'',
                bitacora:'',
                rci:'',
                google:'',
                sapweb:'',
                sapwebvendedor:'',
                sapwebadmin:'',
                reporte:'',
                tickets:'',
                ticketsmantenimiento:'',
              },
              
             
              
            }
        },        
        mounted(){
            this.init()
        },
        computed:{
            ...mapState('admin',['isOk','user']),
            ...mapState('roles',['rol']),
            ...mapState('permiso',['permiso']),
            ...mapState('menus',['menuid'])
        },
        methods:{
            ...mapActions({
                _fetchPermiso: 'permiso/fetchPermisosUsuarios',
                _delete: 'permiso/deleted',
                _create: 'permiso/create', //rol y menu
                _getId: 'menus/getId', // deprecated
                _actualizarRol: 'roles/actualizarRol',
                _fetchRoles:'roles/fetchRoles',// para actualizar todos los roles despues que se hace un cambio.

            }),
            /**
             * Metodo que inicializa los permisos en pantallas que tiene el rol.
             */
            init(){
                this._fetchPermiso(this.rol.id).then(() =>{
                    this.permisos.admin = this.isAdmin(this.permiso)
                    this.permisos.vendedor = this.isVendedor(this.permiso)
                    this.permisos.preprensa = this.isPreprensa(this.permiso)
                    this.permisos.ingenieria = this.isIngenieria(this.permiso)
                    this.permisos.bitacora = this.isBitacora(this.permiso)
                    this.permisos.rci = this.isRCI(this.permiso)
                    this.permisos.google = this.isGoogle(this.permiso)
                    this.permisos.sapweb = this.isSapWeb(this.permiso)
                    this.permisos.sapwebvendedor = this.isSapWebVendedor(this.permiso)
                    this.permisos.sapwebadmin = this.isSapWebAdmin(this.permiso)
                    this.permisos.reporte = this.isReporte(this.permiso)
                    this.permisos.tickets = this.isTickets(this.permiso)
                    this.permisos.ticketsmantenimiento = this.isTicketsMantenimiento(this.permiso)
                })
            },
            /**
             *  metodo que limpia campos y errores.
             */
            onReset(){
                this.clearForm()
                this.clearErrors()
            },
            /**
             * metodo que limpia los campos
             */
            clearForm(){
                Object.assign(this.$data, this.$options.data.apply(this))
            },
            /*
             * metodo que limpia los errores 
             */
            clearErrors(){
                this.reset = true
                this.$validator.reset()
            },
            async onSubmit(evt){
                evt.preventDefault()
                let payload 
                this.reset = false
                const validate = await this.$validator.validateAll()
                if(!validate) {
                    return false
                } 
                
                if ( this.rol.id === undefined){
                     this.$toasted.show('Error al guardar el formulario, regrese a la pantalla anterior', { 
                  				duration : 3000
                          })
                    return false
                }
                /**
                 * borra todo el rol para despues crearlo desde 0 con todos los menus.
                 */
                this._delete(this.rol.id).then(() => {
                    //Object.values(this.permisos).forEach( function(value,prop){
                    let that = this//dentro del foreach no usar this.
                    _.forEach(this.permisos, function(value,key){
                        let menuid = that.pasarMenuDescripcionaId(key)
                        if(value === true ){
                            payload = {
                                'rol':  that.rol.id,
                                'menu' : menuid
                            }
                            that._create(payload).then(()=>{ })
                            
                        }
                    })
                    
                })
                this._actualizarRol(this.rol).then(()=>{
                    this._fetchRoles().then(()=>{
                        this.regresar()
                    })
                 })
                
               
            },
            regresar(){
                this.$router.push('roles')
               
            },
            

        }

        
        
    }
</script>

<style lang="scss" scoped>

</style>